var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorAlarmIcon = function SvgErrorAlarmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25.719
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.922.001a1.678 1.678 0 0 0-1.374.815L.222 23.286a1.587 1.587 0 0 0 0 1.624 1.678 1.678 0 0 0 1.447.809h26.657a1.681 1.681 0 0 0 1.449-.809 1.587 1.587 0 0 0 0-1.624L16.44.816a1.684 1.684 0 0 0-1.518-.815ZM15 6.787a1.073 1.073 0 0 1 1.072 1.072v10a1.073 1.073 0 1 1-2.145 0v-10A1.073 1.073 0 0 1 15 6.787Zm0 12.859a1.072 1.072 0 1 1-1.072 1.072A1.073 1.073 0 0 1 15 19.646Z",
    fill: "#a21f23"
  })));
};
export default SvgErrorAlarmIcon;